module.exports = __webpack_public_path__ + "img/1431550412.a9b4631a.jpg";